var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkFd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.5C38.531 49.5 49.5 38.531 49.5 25C49.5 11.469 38.531 0.5 25 0.5C11.469 0.5 0.5 11.469 0.5 25C0.5 38.531 11.469 49.5 25 49.5Z",
    stroke: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 28.0003L28 22.0003M24 19.0003L24.463 18.4643C25.4008 17.5266 26.6727 16.9999 27.9989 17C29.325 17.0001 30.5968 17.527 31.5345 18.4648C32.4722 19.4026 32.9989 20.6745 32.9988 22.0007C32.9987 23.3268 32.4718 24.5986 31.534 25.5363L31 26.0003M26.0001 31.0003L25.6031 31.5343C24.6544 32.4725 23.3739 32.9987 22.0396 32.9987C20.7054 32.9987 19.4249 32.4725 18.4761 31.5343C18.0085 31.0719 17.6372 30.5213 17.3839 29.9144C17.1305 29.3076 17 28.6565 17 27.9988C17 27.3412 17.1305 26.69 17.3839 26.0832C17.6372 25.4763 18.0085 24.9257 18.4761 24.4633L19.0001 24.0003",
    stroke: "#183883",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkFd);
export default __webpack_public_path__ + "static/media/LinkFD.13f119e6f0bb59b421d317f1cbd31570.svg";
export { ForwardRef as ReactComponent };